import { StatusType, TableColumn, TextWithStatusIndicatorCell } from '@silverfort/sf-components';
import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { InvestigationCell } from '../../InvestigationCell';
import { User } from '../../../types/User';
import { DateFormat, formatDate } from '../../../../../utils/dates';
import { EntityChipSummaryCell } from '../../EntityChipSummaryCell';
import { UsersViewRenderMode } from './UsersViewRenderMode';

const TOTAL_ENTITIES_TO_DISPLAY_IN_COLUMN = 2;

export const useUsersTableColumns = (renderMode = UsersViewRenderMode.BASIC) => {
    const NameColumn: TableColumn<User> = {
        columnKey: 'name',
        render: (user) => {
            return (
                <InvestigationCell
                    adType={user.is_machine_account ? AD_ENTITY_TYPES.SERVER : AD_ENTITY_TYPES.USER}
                    id={user.user_guid}
                    isMachineAccount={user.is_machine_account}
                    name={user.name}
                />
            );
        },
        title: 'User'
    };

    const OusColumn: TableColumn<User> = {
        columnKey: 'ous',
        disableSort: true,
        render: ({ ous }) => {
            if (!ous) return null;

            return <EntityChipSummaryCell entities={ous} limit={TOTAL_ENTITIES_TO_DISPLAY_IN_COLUMN} />;
        },
        title: 'OU'
    };

    const GroupsColumn: TableColumn<User> = {
        columnKey: 'groups',
        disableSort: true,
        render: ({ groups }) => {
            if (!groups) return null;

            return <EntityChipSummaryCell entities={groups} limit={TOTAL_ENTITIES_TO_DISPLAY_IN_COLUMN} />;
        },
        title: 'Groups'
    };

    const ConnectedResourcesColumn: TableColumn<User> = {
        columnKey: 'resources',
        disableSort: true,
        render: ({ resources }) => {
            if (!resources) return null;

            return <EntityChipSummaryCell entities={resources} limit={TOTAL_ENTITIES_TO_DISPLAY_IN_COLUMN} />;
        },
        title: 'Connected resources'
    };

    const StatusColumn: TableColumn<User> = {
        columnKey: 'is_stale',
        render: ({ is_stale }) => (
            <TextWithStatusIndicatorCell
                text={is_stale ? 'Stale' : 'Active'}
                statusType={is_stale ? StatusType.Warning : StatusType.Default}
            />
        ),
        title: 'Status'
    };

    const LastAccessColumn: TableColumn<User> = {
        columnKey: 'last_access',
        render: ({ last_access }) => (last_access ? formatDate(last_access, DateFormat.SHORT_DATE_MD, true) : 'N/A'),
        title: 'Last login'
    };

    return renderMode === UsersViewRenderMode.ADVANCED
        ? [NameColumn, OusColumn, GroupsColumn, ConnectedResourcesColumn, StatusColumn, LastAccessColumn]
        : [NameColumn, StatusColumn, LastAccessColumn];
};
